import { Controller } from "@hotwired/stimulus"

// Flash messages controller for handling global flash messages
//
// Provides functionality for:
// - Auto-dismissing flash messages with timeout
// - Proper cleanup and navigation handling
//
// Usage:
//   <div data-controller="flash-messages">
//     <div data-flash-messages-target="message">Message content</div>
//   </div>
//
export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Flash messages are displayed and will auto-dismiss via the alert component
    // No additional logic needed as the alert component handles auto-dismiss
  }

  disconnect() {
    // Clean up any remaining timers when controller is removed
  }
}